<template>
  <div>
    <div class="registrationSurface">
      <div class="table_conent">
        <div class="search_box">
          <div class="search_box_left">
            <div class="block">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              @change="onPick"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </div>

              
          <!-- <div>
            <el-input
              v-model="params.search_name"
              placeholder="请输入订单号"
              class="el_input_style"
            >
            </el-input
            >  
          </div> -->
           

          <div>
            <el-button
              type="goon"
              style="margin-left:20px"
              icon="el-icon-search"
              @click="onPickSearch_name(0)"
            ></el-button>
          </div>
          </div>
          <div class="totalAmount" style="margin-left: 30px;">
              <el-button
                type="goon"
                style="margin-left:20px"
                @click="onPickSearch_name(1)"
              >
                导出
              </el-button>
          </div>
          <!-- <div class="totalAmount">
             充值总金额 ：<span>{{ samount }}元</span>
          </div> -->
        </div>

        <template>
          <div class="table_title">退款订单</div>
          <el-table
            class="tableBox"
            style="height: 100%"
            :header-cell-style="{
              background: '#F1F6F9',
              color: '#606266',
              width: '100%',
            }"
            :data="tableData"
            border
          >
            <el-table-column label="退款订单号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.order_sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="网吧密钥" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.net_bar_id }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="phone" label="网吧名称" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.user_name }}</span>
                  </template>
                </el-table-column> -->
            <el-table-column prop="dataTime" label="退款台数" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.num }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="dataTime" label="退款天数" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.day }}</span>
                  </template>
                </el-table-column>
            <el-table-column prop="remarks" label="退款时间" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.created_at }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import * as sysApi from "../../common/sys";
export default {
  data() {
    return {
      value1: [new Date(), new Date()],
      tableData: [], // 列表数据
      total: null,
      params: {
        end_time: "",
        page: 1,
        search_name: "",
        start_time: "",
        type: 0
      },
      samount: "0.00",
      //fc_amount: "0.00",
    };
  },
  created() {
    this.initChannelList();
  },
  methods: {
    initChannelList() {
      
      sysApi.refund_order(this.params).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg);
        }
        if (this.params.type === 1) {
             // 假设你有一个表格数据的数组
            let data = [
              ["退款订单号", "网吧密钥", "退款台数", "退款天数", "退款时间"]
            ];

            for (let i = 0; i < res.data.length; i ++) {
              let oDict = res.data[i]
              let myOrder = [oDict.order_sn, oDict.net_bar_id, oDict.num, oDict.day, oDict.created_at]
              data.push(myOrder)
            }
            // 将数据转换为工作表
            const worksheet = XLSX.utils.aoa_to_sheet(data);
      
            // 创建工作簿并添加工作表
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      
            // 生成Excel文件
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      
            // 使用blob和FileReader来处理生成的二进制数据
            const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
            saveAs(dataBlob, 'export.xlsx');
        }else{
          this.total = res.total_count;
          this.tableData = res.data;
        }
      });
    },
    onPickSearch_name(excl) {
      if (excl === 1) {
        this.params.type = 1
      }else {
        this.params.type = 0
      }
      this.initChannelList();
    },
    // 搜索
    // 选择日期
    onPick(val) {
      this.params.start_time = val[0];
      this.params.end_time = val[1];
      this.params.type = 0;
      this.initChannelList();
    },

    // 分页
    handleCurrentChange(val) {
      this.params.page = val;
      this.params.type = 0;
      this.initChannelList();
    },
  },
};
</script>

<style scoped lang="scss">
.search_box {
 
  height: 50px;
  .search_box_left {
    float: left;
    display: flex;
    margin-right: 20px;
    div{
      margin-left: 20px;
    }
  }
  .totalAmount{
    float: right;
  }
}
.el-pagination {
  text-align: right;
}
.registrationSurface {
  // padding: 10px;
  overflow: auto;
  .table_conent {
    padding-top: 10px;
    .table_title {
      border: 1px solid #ebeef5;
      border-bottom: 0px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      height: 49px;
      line-height: 49px;
      background: #f1f6f9;
    }
    .table_btn {
      width: 80px !important;
    }
  }
}
.totalAmount {
  font-size: 16px;
  line-height: 40px;
  span {
    color: red;
    font-weight: bold
  }
}
</style>